export default "__VITE_ASSET__119310e5__"